







































































/* eslint-disable @typescript-eslint/no-var-requires */
import { Vue, Component } from "vue-property-decorator";
import FormattedAddress from "@/components/Address/FormattedAddress.vue";
import VideoRequestStatusIcon from "@/components/VideoRequests/VideoRequestStatusIcon.vue";
import VideoRequestViewDialog from "@/components/VideoRequests/VideoRequestViewDialog.vue";
import { Observer } from "mobx-vue";
import mapStore from "@/store/mapStore";
import userStore from "@/store/userStore";
import { VideoRequestStatus } from "@/api/VideoRequest";
import format from "date-fns/format";
import { TIME_FORMAT } from "@/Constants";
import { videoUrl } from "@/api/VideoRequest";

@Observer
@Component({ components: { FormattedAddress, VideoRequestStatusIcon, VideoRequestViewDialog } })
export default class VideoRequestSummary extends Vue {
  mapStore = mapStore;
  userStore = userStore;
  dispose?: () => void;
  isVideoOpen = false;
  selectedVideoUrl: string | null = null;
  VideoRequestStatus = VideoRequestStatus;

  destroyed() {
    if (this.dispose) {
      this.dispose();
    }
  }

  format(dateString: string) {
    return format(new Date(dateString), TIME_FORMAT);
  }

  getStatusText(status: VideoRequestStatus) {
    switch (status) {
      case VideoRequestStatus.InProgress:
        return "Pending";
      case VideoRequestStatus.Complete:
        return "Complete";
      case VideoRequestStatus.Failed:
        return "Failed";
    }
  }

  viewPropertyVideo(videoRequestId: number) {
    this.selectedVideoUrl = videoUrl(videoRequestId, "Left");
    this.isVideoOpen = true;
  }
  viewHopperVideo(videoRequestId: number) {
    this.selectedVideoUrl = videoUrl(videoRequestId, "Inside");
    this.isVideoOpen = true;
  }

  viewRearVideo(videoRequestId: number) {
    this.selectedVideoUrl = videoUrl(videoRequestId, "Rear");
    this.isVideoOpen = true;
  }

  viewFrontVideo(videoRequestId: number) {
    this.selectedVideoUrl = videoUrl(videoRequestId, "Front");
    this.isVideoOpen = true;
  }

  onVideoRequestViewDialogClose() {
    setTimeout(() => {
      this.selectedVideoUrl = "";
    }, 300);
    this.isVideoOpen = false;
  }
}
